//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const pontoAtendimentoService = {
  doGet,
  doSave,
  findByFiltro,
  doDelete,
  findAllByCliente,
  findAllSemMapa,
  findAll,
};

function findByFiltro(options: Options, filter: any): Promise<any> {
  const params = [];
  if (_.get(filter, 'nome')) {
    params.push(`nome=${encodeURIComponent(filter.nome)}`);
  }
  if (_.get(filter, 'codigo')) {
    params.push(`codigo=${encodeURIComponent(filter.codigo)}`);
  }

  if (_.get(filter, 'clienteNome')) {
    params.push(`clienteNome=${encodeURIComponent(filter.clienteNome)}`);
  }
  if (_.get(options, 'page') !== undefined) {
    params.push(`page=${options.page - 1}`);
  }
  const queryString = params.length ? `?${params.join('&')}` : '';
  return defaultService.doGet(
    `${urlsConstants.API_PONTO_DE_ATENDIMENTO}filtro${queryString}`,
    options
  );
}

function doDelete(id) {
  return defaultService.doDelete(
    `${urlsConstants.API_PONTO_DE_ATENDIMENTO}${id}`
  );
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.API_PONTO_DE_ATENDIMENTO}${id}`);
}

function doSave(pa) {
  return defaultService.doSave(urlsConstants.API_PONTO_DE_ATENDIMENTO, pa);
}

function findAllByCliente(cliente) {
  return defaultService.doGet(
    `${urlsConstants.API_PONTO_DE_ATENDIMENTO}findByCodigoCliente/${cliente.codigoCliente}`
  );
}

function findAll() {
  return defaultService.doGet(
    `${urlsConstants.API_PONTO_DE_ATENDIMENTO}findAll`
  );
}

function findAllSemMapa(cliente) {
  return defaultService.doGet(
    `${urlsConstants.API_PONTO_DE_ATENDIMENTO}sem-mapa/${cliente.codigoCliente}`
  );
}
